import { userForgetPasswordSuccess, userForgetPasswordError } from "./reducer"

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";

import {
  postFakeForgetPwd,
  postJwtForgetPwd,
} from "../../../helpers/fakebackend_helper";
import { APIClient } from "../../../helpers/api_helper";

const fireBaseBackend = getFirebaseBackend();
const api = new APIClient();

export const userForgetPassword = (user, history) => async (dispatch) => {
  try {
      let response;
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {

          response = fireBaseBackend.forgetPassword(
              user.email
          )

      } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
          response = postJwtForgetPwd(
              user.email
          )
      } else {
          // Call backend API for forgot password
          response = api.create("/auth/forgot-password", {
              email: user.email
          });
      }

      const data = await response;

      if (data) {
          dispatch(userForgetPasswordSuccess(
              "Reset link has been sent to your email. Check your inbox for further instructions."
          ))
      }
  } catch (forgetError) {
      dispatch(userForgetPasswordError(forgetError))
  }
}

export const resetPassword = (data, history) => async (dispatch) => {
  try {
      const response = await api.create("/auth/reset-password", {
          token: data.token,
          newPassword: data.newPassword
      });

      if (response && response.data) {
          sessionStorage.setItem("authUser", JSON.stringify(response.data));
          dispatch(userForgetPasswordSuccess(
              "Password reset successfully! Redirecting to dashboard..."
          ))
          setTimeout(() => {
              history('/dashboard');
          }, 2000);
      }
  } catch (error) {
      dispatch(userForgetPasswordError(error))
  }
}